var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodFatMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B3E2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8506 6.75717C19.8506 6.75717 17.0371 9.23413 17.0371 11.6583C17.0371 13.2117 18.2971 14.4717 19.8506 14.4717C21.4041 14.4717 22.6641 13.2117 22.6641 11.6583C22.6641 9.44543 19.8506 6.75717 19.8506 6.75717Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6548 16.0193C17.3187 16.0193 15.4267 14.1254 15.4267 11.7913C15.4267 10.813 15.7339 9.82891 16.18 8.91326C14.7889 7.17 13.5661 6 13.5661 6C13.5661 6 7 11.7815 7 17.4339C7 21.0593 9.9387 24 13.5661 24C17.1935 24 20.1322 21.0613 20.1322 17.4339C20.1322 16.9643 20.0774 16.485 19.9776 16.0037C19.87 16.0115 19.7643 16.0193 19.6548 16.0193ZM16.6202 18.3085H14.5443V20.3843C14.5443 20.9243 14.1061 21.3626 13.5661 21.3626C13.0261 21.3626 12.5878 20.9243 12.5878 20.3843V18.3085H10.512C9.97196 18.3085 9.5337 17.8702 9.5337 17.3302C9.5337 16.7902 9.97196 16.352 10.512 16.352H12.5878V14.2761C12.5878 13.7361 13.0261 13.2978 13.5661 13.2978C14.1061 13.2978 14.5443 13.7361 14.5443 14.2761V16.352H16.6202C17.1602 16.352 17.5985 16.7902 17.5985 17.3302C17.5985 17.8702 17.1602 18.3085 16.6202 18.3085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodFatMark);
export default __webpack_public_path__ + "static/media/blood_fat_mark.ff1cf19d74aafa791859ac8cfb11dd1d.svg";
export { ForwardRef as ReactComponent };